import React, {Component} from "react";
import app_cs from "./map.module.css";
import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import $ from 'jquery'
import img_agriculture from 'assets/images/pc/img_agriculture.png'
import img_gas from 'assets/images/pc/img_gas.png'
import img_nuclear from 'assets/images/pc/img_nuclear.png'
import img_money from 'assets/images/pc/img_money.png'
import icon_gas from 'assets/images/pc/icon_gas.png'
import icon_nuclear from 'assets/images/pc/icon_nuclear.png'
import icon_money from 'assets/images/pc/icon_money.png'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

class App extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let _self =this;

        let _t_history= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_history_wrapper'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'+=10000',
                pin:true,
                anticipatePin: 1,
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(0)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        _t_history.to('.'+app_cs['background-image-history'],{opacity:1,duration:0})
            .to('.'+app_cs['content_history_middle_text'],{opacity:0,duration:2},'<')
            .to('.'+app_cs['content_history_para'], {opacity:1,duration:2})
            /*info1*/
            .to('.'+app_cs['content_history_para1']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info1'],{opacity:1,duration:2},'<')
            .to('.'+app_cs['content_history_middle_arrow1'],{opacity:1,duration:2},)

            /*info1*/
            /*info2*/
            .to('.'+app_cs['content_history_para1']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info1'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_middle_arrow1'],{opacity:0,duration:1},"<")
            .to('.'+app_cs['content_history_para2']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info2'],{opacity:1,duration:2},'<')
            .to('.'+app_cs['content_history_middle_arrow2'],{opacity:1,duration:2},)
            /*info2*/
            /*info3*/
            .to('.'+app_cs['content_history_para2']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info2'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_middle_arrow2'],{opacity:0,duration:1},"<")
            .to('.'+app_cs['content_history_para3']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info3'],{opacity:1,duration:2},'<')
            /*info3*/
            /*info4*/
            .to('.'+app_cs['content_history_para3']+' .'+app_cs['content_history_para_mark'], {
                background:'#8F8F8F',
                duration:1,
            })
            .to('.'+app_cs['content_history_middle_info3'],{opacity:0,duration:1},'<')
            .to('.'+app_cs['content_history_para4']+' .'+app_cs['content_history_para_mark'], {
                background:'#CD5C28',
                duration:2,
            })
            .to('.'+app_cs['content_history_middle_info4'],{opacity:1,duration:2},'<')
            /*info4*/
            .to('.'+app_cs['content_history_middle_info4'],{opacity:0,duration:1},)
        .to('.'+app_cs['content_history_para'], {opacity:0,duration:1})
        .to('.'+app_cs['background-image-history'],{opacity:0,duration:1},"<")


        let t_start = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['info'],
                pin: "."+app_cs['background'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                end:'bottom bottom',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                anticipatePin: 1,
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });


        let t1991 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_1'],
                endTrigger:"."+app_cs['content_para_1991_4'],
                pin: "."+app_cs['content_time_wrapper_1'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(1)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });



        let t1991_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1991'],
                endTrigger:"."+app_cs['content_para_1991_4'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar

            }
        });
        t1991_ .to('.'+app_cs['background-image-1991-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-1'],{opacity:0,duration:1})
            .to('.'+app_cs['background-image-1991-2'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1991-3'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-2'],{opacity:0,duration:0})
            .to('.'+app_cs['background-image-1991-4'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1991-3'],{opacity:0,duration:1})
        ;

        let t1994 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_2'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(2)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });


        let _t1994_1999 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1994'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                endTrigger:"."+app_cs['content_para_1999'],
                // end:'bottom top+=60.45%',
                end:'top top',
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });

        _t1994_1999.to('.'+app_cs['background-image-1991-4'],{opacity:0,duration:1})
            .to('.'+app_cs['background-image-1999-1'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-font'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-font'],{opacity:0,duration:0},)
            .to('.'+app_cs['background-image-1999-1'],{scale:1.6,opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-1999-2'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1999-1'],{scale:1.6,opacity:0,duration:0});

        let t1999= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_3'],
                endTrigger:"."+app_cs['content_para_1999_2'],
                pin: "."+app_cs['content_time_wrapper_3'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(3)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });
        t1999.to('.'+app_cs['content_pic_1999'],{opacity:0,duration:1})
            .to('.'+app_cs['content_pic_1999'],{opacity:1,duration:1});


        let t2004 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_4'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(4)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2004_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_1999_2'],
                start: "top top-=10%", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                endTrigger: "."+app_cs['content_para_2004'],
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2004_.to('.'+app_cs['background-image-2004-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-1999-2'],{opacity:0,duration:0});

        let t2008 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_5'],
                start: "top top+=1px", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(5)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2008_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2008'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2008_.to('.'+app_cs['background-image-2008-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2004-1'],{opacity:0,duration:0},);

        let t2009 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_6'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(6)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2009_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2009'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2009_.to('.'+app_cs['background-image-2009-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2008-1'],{opacity:0,duration:0});

        let t2013 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_7'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(7)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2013_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2013'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2013_.to('.'+app_cs['background-image-2013-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2009-1'],{opacity:0,duration:0},);

        let t2014= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_8'],
                endTrigger:"."+app_cs['content_para_2014_3'],
                pin: "."+app_cs['content_time_wrapper_8'],   // pin the trigger element while active
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(8)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });


        let t2014_img2= gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2014_3'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                end:'top top+=50%',
                // pin:true,
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2014_img2.to('.'+app_cs['content_pic_2014'],{opacity:0,duration:1})
        t2014_img2.to('.'+app_cs['content_pic_2014_2'],{opacity:1,duration:1},"<")

        let t2014_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2014'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                endTrigger:'.'+app_cs['content_para_2014_3'],
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2014_.to('.'+app_cs['background-image-2013-1'],{opacity:0,duration:2})
            .to('.'+app_cs['background-image-2014-1'],{opacity:1,duration:2},"<")
            .to('.'+app_cs['background-image-2014-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2014-1'],{opacity:0,duration:2},)
            .to('.'+app_cs['background-image-2014-2'],{opacity:1,duration:2},"<");

        let t2019 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_9'],
                start: "top top", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(9)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2019_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2019'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                fastScrollEnd:true,
                preventOverlaps:true,
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar

            }
        });
        t2019_.to('.'+app_cs['background-image-2014-2'],{opacity:0,duration:2},)
            .to('.'+app_cs['background-image-2019-1'],{opacity:1,duration:2},"<");

        let t2022 = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_time_wrapper_10'],
                start: "top top+=10%", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'bottom top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                // markers:true,
                fastScrollEnd:true,
                preventOverlaps:true,
                onToggle: self => {
                    if(self.isActive){
                        _self.props.changeYear(10)
                    }
                    else{
                        _self.props.changeYear(null)
                    }
                }
            }
        });

        let t2022_ =  gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: "."+app_cs['content_para_2022'],
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                // end:'bottom top+=60.45%',
                end:'top top',
                // end: "+=5000", // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                fastScrollEnd:true,
                preventOverlaps:true,
            }
        });
        t2022_.to('.'+app_cs['background-image-2022-1'],{opacity:1,duration:2})
            .to('.'+app_cs['background-image-2019-1'],{opacity:0,duration:0});

    }

    render() {
        return (
            <section  className={app_cs['container']}>

                <div className={app_cs['infoWrapper']}>
                    <div className={app_cs['content_history_wrapper']} >
                        <div className={app_cs['background-image-history']}></div>

                        {/*<div className={app_cs['content_history_part1']} style={{height:'100vh'}}>*/}
                        {/*</div>*/}
                        <div className={app_cs['content_history_part2']} style={{height:'100vh'}}>
                            <div className={app_cs['content_history_point']}></div>

                            <div className={app_cs['content_history_middle_text']}>
                                Ukraine is located in Eastern Europe, and used to be part of the Soviet Union, officially the Union of Soviet Socialist Republics (USSR). It is the second largest country in Europe after Russia, with which it shares a near 2,000-kilometer land border to the northeast.
                            </div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info1']}>
                                <img src={img_agriculture} className={app_cs['content_history_middle_img']}></img>
                            </div>

                            <div className={ app_cs['content_history_middle_arrow1']}></div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info2']}>
                                <img src={img_gas} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_gas} className={app_cs['content_history_middle_icon']}></img>
                            </div>

                            <div className={ app_cs['content_history_middle_arrow2']}></div>

                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info3']}>
                                <img src={img_nuclear} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_nuclear} className={app_cs['content_history_middle_icon']}></img>
                            </div>
                            <div className={app_cs['content_history_middle_info']+ ' '+ app_cs['content_history_middle_info4']}>
                                <img src={img_money} className={app_cs['content_history_middle_img']}></img>
                                <img src={icon_money} className={app_cs['content_history_middle_icon_right']}></img>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para1']} style={{top:'16.76vh',left:'11.51vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                    Breadbasket of Europe
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>Ukraine boasts a quarter of the world's fertile black soil and 71 percent of the country's land is agricultural. It is the fourth largest global exporter of corn and fifth of wheat, in addition to being the world's largest exporter of sunflower oil. It produced 40 percent of the world's sunflower oil in 2020.</p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para2']} style={{top:'11.203vh',left:'56.98vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                    Key energy supply route
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>Ukraine is home to a series of pipelines that are crucial to Russia-Europe energy trading. In 2021, 41.6 billion cubic meters of Russian gas were transported through Ukraine to Europe, accounting for 26.8 percent of Europe's total gas imports from Russia.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para3']} style={{top:'55.93vh',left:'19.22vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                    Soviet nuclear inheritor
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>Ukraine has four nuclear power plants (NPP), all of which were commissioned during the Soviet era. Its Zaporizhzhia plant is the largest NPP in Europe. In 2020, Ukraine generated 76,202 GWh of electricity from nuclear power, ranking seventh in the world.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className={app_cs['content_history_para']+ ' '+ app_cs['content_history_para4']} style={{top:'51.02vh',left:'62.60vw'}}>
                                <div className={app_cs['content_history_para_mark']} ></div>
                                <div className={app_cs['content_history_para_title']} >
                                    Links with NATO members
                                </div>
                                <div className={app_cs['content_history_description']} >
                                    <div className={app_cs['content_history_description_back']}></div>
                                    <div className={app_cs['content_history_description_content']}>
                                        <p>
                                            Ukraine-NATO relations started in the early 1990s soon after the country's independence from the USSR. Ukraine is also <span className={app_cs['importantDesc']}>one of the leading recipients of aid from NATO members</span>. From 2014 to 2021, Ukraine received more than $2.5 billion in military aid from the U.S.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className={app_cs['content_history_part_empty']} style={{height:'100vh'}}></div>
                        <div className={app_cs['history-timeline']}></div>
                    </div>
                    <div className={app_cs['info']}>
                        <div className={app_cs['background']}>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-3']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1991-4']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1994-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-font']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-1999-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2004-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2008-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2009-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2013-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2014-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2014-2']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2019-1']}></div>
                            <div className={app_cs['background-image'] + ' ' +app_cs['background-image-2022-1']}></div>
                        </div>
                        <div className={app_cs['content_wrapper']} >
                            <div className={app_cs['content_left']}>
                                {/* start 1991 */}
                                <div style={{height:'100vh'}}></div>
                                <div className={app_cs['content_para_1991']} style={{paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Ukraine becomes independent
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>In 1991, Ukraine became an independent country after the collapse of the USSR, which was made up of 15 republics: Armenia, Azerbaijan, Belarus, Estonia, Georgia, Kazakhstan, Kyrgyzstan, Latvia, Lithuania, Moldova, Russia, Tajikistan, Turkmenistan, Ukraine and Uzbekistan. </p>
                                            <p>The Act of Independence was backed by a majority of voters in all of Ukraine's 27 administrative regions, but received a lower level of support in areas of Eastern Ukraine where there were more Russian speakers, including Luhansk, Donetsk and Crimea, as well as regions such as Kharkiv and Odesa.</p>

                                            <p>Ukraine is bordered by Russia to the northeast and Belarus to the north, while NATO members lie to its west and south.</p>

                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_2']} style={{marginTop:'74.63vh',paddingTop:'45%'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p><span className={app_cs['importantBold']} >What is NATO?</span><br/> The North Atlantic Treaty Organization was created in 1949 by the  <span className={app_cs['importantDesc']} >U.S., Canada and several Western European nations. </span>
                                                The military alliance now includes  <span className={app_cs['importantDesc']} >30 countries. </span>
                                               <div>(Map reflects the period from October 3, 1990 to June 25, 1991.)</div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_3']} style={{marginTop:'74.63vh',paddingTop:'25.37vh'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> <span className={app_cs['importantBold']} >What was the Warsaw Pact? </span><br/> The Warsaw Pact was created in 1955 after the accession of West Germany to NATO. It was composed of the Soviet Union and seven other Soviet satellite states in Central and Eastern Europe.</p>
                                        </div>
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                                The Warsaw Pact embodied what was referred to as the Eastern bloc, while NATO represented the Western bloc. They were ideologically opposed and, over time, built up their own defenses starting an arms race that lasted throughout the Cold War. The alliances were not always in conflict with one another. In 1990, NATO and Warsaw Pact states signed the Conventional Armed Forces in Europe treaty (CFE) and published a joint declaration on non-aggression.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1991_4']} style={{marginTop:'74.63vh',paddingTop:'45%'}}>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>East Germany left the Warsaw Pact upon reunification with West Germany in 1990. The Warsaw Pact was declared at an end in 1991, and the Soviet Union collapsed that year.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 1991 */}

                                {/* start 1994 */}

                                <div className={app_cs['content_para_1994']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Budapest<br/>
                                        Memorandum
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> After the collapse of the Soviet Union in 1991, the newly independent Ukraine was left in possession of the world's third-largest nuclear weapon stockpile. It had some 1,900 strategic warheads – all designed and built by the USSR.</p>

                                            <p> Belarus and Kazakhstan found themselves in similar situations. Eliminating these nuclear warheads became the subject of intense interest to both Washington and Moscow. On December 5, 1994, the Budapest Memorandum was signed at the Budapest Summit of the Conference on Security and Cooperation in Europe (CSCE) to provide security assurances to Belarus, Kazakhstan and Ukraine. In exchange for the three countries giving up their nuclear weapons, the U.S., UK and Russia promised not to use military force or economic coercion against them.
                                            </p>

                                            <p>At a NATO Foreign Ministers meeting held in Brussels earlier in the same month, the military alliance began open discussions about its expansion eastward, saying it "would welcome NATO enlargement that would reach to democratic states to our East." Russian President Boris Yeltsin was furious. At the Budapest Summit, he accused the "domineering" U.S. of "trying to split the continent again" through NATO expansion. </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 1994 */}
                                {/* start 1999 */}
                                <div className={app_cs['content_para_1999']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Former Warsaw Pact countries join NATO
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> In January 1999, NATO sent a formal invitation to the former Warsaw Pact countries of Poland, Hungary and the Czech Republic to enter the alliance. On March 12, 1999, the three countries officially signed up, bringing NATO's sphere of influence further to the east amid much debate within the alliance itself and fierce opposition from Russia. It was the first wave of NATO expansion.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_1999_2']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>


                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                                In the same month, NATO carried out an aerial bombing campaign against the Federal Republic of Yugoslavia during the Kosovo War. For Moscow, the move was a drastic provocation and rang an alarm that its efforts to maintain cordial relations with the West may have been a mistake. As former Yugoslav diplomat Vesko Garcevic pointed out, NATO's unilateral decision to bomb Yugoslavia without the UN's approval marked a turning point in Russia's relationship with the West.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {/* end 1999 */}

                                {/* start 2004 */}

                                <div className={app_cs['content_para_2004']} style={{marginTop:'100vh',paddingTop:'8.93vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Baltic states<br/>
                                        join NATO
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                                On March 29, 2004, NATO welcomed seven new members: Bulgaria, Romania, Slovakia, Slovenia, Estonia, Latvia and Lithuania. The latter three are together known as the Baltic states. </p>

                                            <p> From the late 18th to early 20th century, the Baltic states were part of the Russian empire. The three states' coastlines greatly expanded Russia's access to the Baltic Sea, control of which was key to exerting geopolitical influence in Europe. Wars were fought throughout history for control of the sea and its maritime trade routes.</p>

                                            <p> Initially, the idea of the Baltic nations joining NATO was not well-received by U.S. policymakers, because of the countries' deep historical ties with Russia. But the Baltic states went out of their way to appeal to the West. After gaining independence in 1991, these countries were determined to join NATO and the European Union and went through political and economic reforms to meet the entry requirements. <span className={app_cs['importantDesc']}>In 2004, they became the first post-Soviet states to join NATO. </span></p>

                                            <p> Russian Foreign Minister Sergey Lavrov called NATO's eastward expansion a mistake back in 2004. "The presence of American soldiers on our border has created a kind of paranoia in Russia," Lavrov said in a meeting with NATO ministers in Brussels that year.

                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2004 */}

                                {/* start 2008 */}

                                <div className={app_cs['content_para_2008']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Ukraine asks for <br/>
                                        membership
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> In March 2008, under Ukrainian President Viktor Yushchenko and Prime Minister Yulia Tymoshenko, Ukraine sent an official letter of application for a Membership Action Plan (MAP), the first step to joining NATO.</p>

                                            <p> In April, the NATO summit in Bucharest began with intense debates on whether membership should be extended to Ukraine. Russian President Vladimir Putin was also invited. 
                                            </p>
                                            <p>While the U.S. and Poland strongly supported Ukraine joining the alliance, the UK, France and Germany contested the idea. In the end, Ukraine was not offered membership, but NATO Secretary General Jaap de Hoop Scheffer promised that the door was open for Ukraine and Georgia to join one day.</p>
                                            <p>NATO also said its ballistic missile defense systems deployed in member countries were not directed against Russia, but Putin warned such claims would not ease Russia's concerns. "National security is not based on promises, and the statements made prior to the bloc's previous waves of expansion simply confirm this," Putin said at a press conference following a Russia-NATO meeting on April 4.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2008 */}


                                {/* start 2009 */}

                                <div className={app_cs['content_para_2009']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Albania and Croatia<br/>
                                        join NATO
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                                In 2009, Albania and Croatia became new inductees of NATO's expanding alliance. With the accession of Albania, most members of the Warsaw Pact aside from Russia have joined NATO.

                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2009 */}

                                {/* start 2013 */}

                                <div className={app_cs['content_para_2013']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Maidan protests
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>In November 2013, waves of protests began in Ukraine after President Viktor Yanukovych turned down an EU-Ukraine Association Agreement and instead pursued closer ties with Russia. The unrest escalated and culminated in February 2014, when clashes between protesters and police became deadly. </p>

                                            <p>To end the bloodshed, on February 21, Yanukovych and leaders of the parliamentary opposition signed an agreement calling for the formation of a coalition government, constitutional reforms and a presidential election by December 2014. But the next day, Yanukovych was voted out of office by the Ukrainian parliament.</p>

                                            <p>Meanwhile, the Crimean parliament stated that because of the events in Kyiv, the autonomous region was ready to join Russia. On February 27, armed men seized the parliament building and raised the flag of the Russian Federation. </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2013 */}

                                {/* start 2014 */}
                                <div className={app_cs['content_para_2014']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Crimea crisis
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> In a referendum held on March 16, 2014, Russia asked the people of Crimea to decide the peninsula's fate: to join Russia or remain as part of Ukraine. Ninety-seven percent voted to join Russia. </p>

                                            <p>On March 18, 2014, the Treaty on Accession of the Republic of Crimea to Russia was signed by representatives of Crimea and Russia, formally admitting Crimea as two Russian federal subjects – the Republic of Crimea and the federal city of Sevastopol. The Ukrainian government did not recognize the referendum. On April 15, the Ukrainian parliament declared Crimea to be a "territory temporarily occupied" by Russia. NATO backed Ukraine, calling the referendum "a direct violation of the Ukrainian constitution and international law."</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={app_cs['content_para_2014_3']} style={{marginTop:'100vh',paddingTop:'25.37vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Uprisings<br/> in eastern Ukraine
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>
                                                Meanwhile, pro-Russian and anti-Maidan demonstrations took place across major cities in southern and eastern Ukraine. In early March, local forces took control of government buildings in Donetsk, Luhansk and Kharkiv oblasts. By mid-May, Donetsk and Luhansk effectively became breakaway regions in Ukraine after both held referendums.  </p>

                                                <p>    After a previous peace attempt had failed, representatives of Russia, Ukraine, the Organization for Security and Cooperation in Europe (OSCE) and the leaders of the Donetsk and Luhansk regions gathered in Minsk and signed another 15-point agreement in February 2015 known as Minsk II. In the end, the agreement failed to deliver a ceasefire in eastern Ukraine, as Moscow and Kyiv interpreted the pact very differently.


                                                </p>
                                        </div>
                                    </div>
                                </div>
                                {/* end 2014 */}

                                {/* start 2019 */}

                                <div className={app_cs['content_para_2019']} style={{marginTop:'100vh',paddingTop:'6.39vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Zelenskyy becomes Ukraine's president
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p> In 2019, Ukrainian actor and comedian Volodymyr Zelenskyy won a landslide victory against incumbent president Petro Poroshenko. After winning more than 70 percent of the vote in the second round of the contest, he was inaugurated as Ukraine's sixth president on May 20. </p>

                                            <p>In his campaign, Zelenskyy promised to smooth tensions with Russia and end the conflict in the east of his country. However, Ukraine's ties with NATO deepened as Russia-Ukraine relations continued to deteriorate. In June 2020, Ukraine was  <span className={app_cs['importantDesc']} > recognized by NATO as an Enhanced Opportunities Partner</span>, joining Australia, Finland, Georgia, Jordan and Sweden. NATO claimed the new status did not "prejudge" formal membership, but said Ukraine would continue to receive support from NATO allies "in the security and defense sector."
                                            </p>

                                            <p> In 2021, three television channels in Ukraine were shut down for "spreading Russian disinformation." Putin expressed concern that Ukraine was turning into a "polar opposite of Russia," which now required Russia's "special attention from a security point of view."</p>

                                            <p>At the end of 2021, in order to deescalate tensions on the Russia-Ukraine border, Putin urged the West to provide security guarantees which would preclude NATO's expansion into Ukraine and stop the deployment of weapons in the alliance's eastern flank. The West largely ignored Putin's demands and cited NATO's "open-door policy."</p>

                                        </div>
                                    </div>
                                </div>

                                {/* end 2019 */}

                                {/* start 2022 */}

                                <div className={app_cs['content_para_2022']} style={{marginTop:'100vh',paddingTop:'23.01vh'}}>
                                    <div className={app_cs['content_para_title']}>
                                        Putin recognizes two "independent republics"
                                    </div>

                                    <div className={app_cs['content_para_description']}>
                                        <div className={app_cs['content_para_description_back']}></div>
                                        <div className={app_cs['content_para_description_content']}>
                                            <p>On February 22, 2022, Moscow recognized the "Donetsk People's Republic" and the "Luhansk People's Republic," a move which Kyiv called a violation of Ukraine's sovereignty. Two days later, in a TV address, Putin declared a "special military operation" to "demilitarize" and "denazify" Ukraine would begin. He said the "operation" would not include the occupation of Ukrainian territory. Shortly after, the Russian military launched multiple strikes on dozens of military targets inside Ukraine.  </p>
                                        </div>
                                    </div>
                                </div>

                                {/* end 2022 */}

                            </div>

                            <div className={app_cs['content_right']}>
                                <div className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_1'] }>
                                    <div className={app_cs['content_time']}>1991</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>

                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_2'] }>
                                    <div className={app_cs['content_time']}>1994</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_1994'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_3'] }>
                                    <div className={app_cs['content_time']}>1999</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_1999'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_4'] }>
                                    <div className={app_cs['content_time']}>2004</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_5'] }>
                                    <div className={app_cs['content_time']}>2008</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2008'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_6'] }>
                                    <div className={app_cs['content_time']}>2009</div>
                                    <div className={app_cs['content_point']}></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_7'] }>
                                    <div className={app_cs['content_time']}>2013</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2013'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_8'] }>
                                    <div className={app_cs['content_time']}>2014</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic_wrapper']}>
                                        <div className={app_cs['content_pic_2014'] } ></div>
                                        <div className={app_cs['content_pic_2014_2'] } ></div>
                                    </div>

                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_9'] }>
                                    <div className={app_cs['content_time']}>2019</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2019'] } ></div>
                                </div>
                                <div style={{marginTop:'100vh'}} className={app_cs['content_time_wrapper']+' '+app_cs['content_time_wrapper_10'] }>
                                    <div className={app_cs['content_time']}>2022</div>
                                    <div className={app_cs['content_point']}></div>
                                    <div className={app_cs['content_pic']+' '+app_cs['content_pic_2022'] } ></div>

                                    <div className={app_cs['copyright']}>
                                        <div className={app_cs['copyright_text']}>Please note that all maps shown in this interactive product are indicative only, and actual boundaries may vary.<br/>
                                            Copyright © 2022 CGTN All Rights Reserved.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>)
    }
}

export default App;